import { Box } from "@mui/material";
import { authScreenStyles } from "../../../_styles/authScreen.styles";
import Logo from '../../../_assets/images/Coillte_Logo_Default.jpg';

export function AuthLogo() {

    return (
        <Box component="img" src={Logo} alt="Company Logo" sx={authScreenStyles.logo} />
    );
}